@if (isLoading$ | async) {
<div class="loading-overlay">
    Cargando... <!-- Puedes reemplazar esto con un spinner u otro indicador -->
</div>
}

@if ((isInstallable$ | async) && !(isLoading$ | async)) {
<div class="pwa-style">
    <ngb-toast header="Instalación APP Pacientes" [autohide]="false">
        <div>La APP Pacientes <br>
            no está instalada en este dispositivo.</div>
        <button class="btn btn-primary" (click)="installPwa()">Instalar</button>
    </ngb-toast>
</div>
}
@if (!(isInstallable$ | async) && !(isLoading$ | async)) {
<router-outlet />
}